import Vue from 'vue'
import apiClient from '@/services/axios'
// import router from '@/router'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async FETCH_DISCOUNTED_COURSE() {
      try {
        const { data: { data } } = await apiClient.get('/discounted-course')
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_DISCOUNTED_COURSE_BY_ID_COURSE(_, { idCourse }) {
      try {
        const { data: { data } } = await apiClient.get('/discounted-course/course/' + idCourse)
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async ADD_DISCOUNTED_COURSE(_, payload) {
      try {
        const { data: { data } } = await apiClient.post('/discounted-course', payload)
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async EDIT_DISCOUNTED_COURSE(_, { payload, idDiscountedCourse:id }) {
      try {
        const { data: { data } } = await apiClient.put('/discounted-course/' + id, payload)
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async DELETE_DISCOUNTED_COURSE(_, { idDiscountedCourse:id }) {
      try {
        const { data: res } = await apiClient.delete('/discounted-course/' + id)
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
  },
  modules: {
  },
  getters: {
    // userDetail() {
    //   return Vue.$cookies.get('user')
    // },
  },
}
